import { EventGQL } from '../../Api/Events/events.types'

/**
 *
 * Map a live event to just the data needed to update the event in season events state
 */
export const mapLiveEventForSeasonEventsUpdate = (ev: EventGQL) => {
    return {
      eventStatus: ev.eventStatus,
      period: ev.period,
      clockMinutes: ev.clockMinutes,
      clockSeconds: ev.clockSeconds,
      visitorScore: ev.visitorScore,
      homeScore: ev.homeScore,
      visitorPeriodScores: ev.visitorPeriodScores,
      homePeriodScores: ev.homePeriodScores,
  
    }
  }